import { WOD_ADD_KNOWN_WORD_FAILED, WOD_ADD_KNOWN_WORD_SUCCEEDED, GET_WORD_PACKET, WORD_ARRAY_ADD_KNOWN_WORD_SUCCEEDED, WORD_ARRAY_ADD_KNOWN_WORD_FAILED, ADD_WORD_TO_LEARN, SIGN_IN, SIGN_OUT, SKIP_WORD_FROM_WORD_PACKET } from "../actions/types"


const initialState = {
    wordOfTheDay:
    {
        word: "",
        definition: ""
    },
    wordsPacket: []
}

const wordPacketReducer = (state = initialState, { type, payload }) => {
    let wordOfDay;
    let newWordsPacket;
    switch (type) {

        case SIGN_IN:
            return initialState;

        case SIGN_OUT:
            return initialState;

        case GET_WORD_PACKET:

            return {
                wordOfTheDay: payload.wordOfDayResponse,
                wordsPacket: payload.wordsArray
            };
        case WOD_ADD_KNOWN_WORD_FAILED:
            if (state.wordOfTheDay && state.wordsPacket[0]) {
                if (state.wordOfTheDay.word === state.wordsPacket[0].word) {

                    newWordsPacket = state.wordsPacket.splice(1);
                }
            }
            return {
                wordOfTheDay: null,
                wordsPacket: state.wordsPacket
            }
        case WOD_ADD_KNOWN_WORD_SUCCEEDED:
            if (state.wordOfTheDay && state.wordsPacket[0]) {
                if (state.wordOfTheDay.word === state.wordsPacket[0].word) {

                    newWordsPacket = state.wordsPacket.splice(1);
                }
            }
            return {
                wordOfTheDay: null,
                wordsPacket: state.wordsPacket
            }
        case SKIP_WORD_FROM_WORD_PACKET:
            newWordsPacket = state.wordsPacket.splice(1);
            return {
                wordOfTheDay: state.wordOfTheDay,
                wordsPacket: newWordsPacket
            }

        case WORD_ARRAY_ADD_KNOWN_WORD_SUCCEEDED:
            wordOfDay = state.wordOfTheDay;
            if (state.wordOfTheDay && state.wordsPacket[0]) {
                if (state.wordOfTheDay.word === state.wordsPacket[0].word) {

                    wordOfDay = null;
                }
            }

            return {
                wordOfTheDay: wordOfDay,
                wordsPacket: state.wordsPacket.splice(1)
            }
        case WORD_ARRAY_ADD_KNOWN_WORD_FAILED:
            wordOfDay = state.wordOfTheDay;
            if (state.wordOfTheDay && state.wordsPacket[0]) {

                if (state.wordOfTheDay.word === state.wordsPacket[0].word) {

                    wordOfDay = null;
                }
            }
            return {
                wordOfTheDay: wordOfDay,
                wordsPacket: state.wordsPacket.splice(1)

            }

        case ADD_WORD_TO_LEARN:
            wordOfDay = state.wordOfTheDay;
            newWordsPacket = state.wordsPacket;
            if (state.wordOfTheDay) {
                if (payload.word === state.wordOfTheDay.word) {
                    wordOfDay = null;
                }
            }
            if (state.wordsPacket[0]) {
                if (payload.word === state.wordsPacket[0].word) {
                    newWordsPacket = state.wordsPacket.splice(1);
                }
            }
            return {
                wordOfTheDay: wordOfDay,
                wordsPacket: newWordsPacket
            };
        default:
            return state;
    }
}

export default wordPacketReducer;
